<template>
  <div ref="reviewContainer" :class="{ 'loading-container': isLoading }">
    <template v-if="showReviews">
      <Review
        v-for="review in preparedReviews"
        :key="review.id"
        v-bind="review.props"
        v-on="review.events"
        class="review"
      />
    </template>
    <div v-else-if="!isLoading" class="no-data">
      {{ $t("message.reviewBooster.reviews.noData") }}
    </div>
  </div>
</template>
<script>
import Review from "@/components/ReviewBooster/Review";

export default {
  name: "ReviewListContainer",
  components: {
    Review
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    reviews: {
      type: Array
    },
    tags: {
      type: Array
    }
  },
  computed: {
    showReviews() {
      return !!(this.reviews && this.reviews.length);
    },
    preparedReviews() {
      const firstReviewEvents = {
        "tags-height-changed": this.onTagsHeightChanged
      };
      return this.reviews.map((review, index) => ({
        id: review.id,
        props: this.getReviewProps(review, index),
        events: index === 0 ? firstReviewEvents : {}
      }));
    }
  },
  methods: {
    onTagsHeightChanged(height) {
      this.$refs.reviewContainer.style.setProperty(
        "--review-tags-height",
        `${height}px`
      );
    },
    getReviewProps(review, index) {
      const props = {
        item: review,
        tags: this.tags
      };

      if (index === 0) {
        props.isFirstElement = true;
      }

      return props;
    }
  }
};
</script>
<style lang="scss" scoped>
.no-data {
  text-align: center;
  padding-top: 40px;
  max-width: 500px;
  margin: auto;
  font-weight: 600;
  @include font-size(22px);
  line-height: 28px;
}

.loading-container {
  min-height: 50vh;
}

.review {
  margin-bottom: $spacing * 3;
  padding-bottom: $spacing * 3;
  border-bottom: 1px solid $gray-200;
  ::v-deep .tags-selector {
    min-height: var(--review-tags-height);
  }
}
</style>
